// Settings
import { showDebugLogs } from "../settings";
import { firebaseAppCheckSiteKey, firebaseConfig } from "../config/firebase";
import { isProductionApp, isStagingApp } from "../config/appEnv";

// Firebase
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getApp, getApps, initializeApp } from "firebase/app";
import { getToken, initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

const appCheckDebugToken = process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN?.trim();

if (isProductionApp) {
    if (!showDebugLogs) console.log(` ******* FIREBASE ${isProductionApp ? "PRODUCTION" : "STAGING"} ✅******`);

    try {
        // Initialize App Check
        const appCheck = initializeAppCheck(app, {
            provider: new ReCaptchaEnterpriseProvider(firebaseAppCheckSiteKey),
            isTokenAutoRefreshEnabled: false, // Enables token auto-refresh
        });

        // Function to get the token
        const getAppCheckToken = async () => {
            let retries = 0;
            let delay = 1000;
            try {
                while (retries < 3) {
                    // Get the token
                    if (showDebugLogs) console.log("BEFORE ASKING FOR TOKEN");
                    const tokenResult = await getToken(appCheck, true);
                    if (showDebugLogs) console.log("App Check Token:", tokenResult.token);
                    return;
                }
            } catch (error) {
                console.error(`Attempt ${retries}: Error retrieving App Check token:`, error);

                retries++;

                await new Promise(resolve => setTimeout(resolve, delay));

                delay *= 2;
            }
        };

        // Call the function to fetch the token
        getAppCheckToken();
    } catch (error) {
        console.error("App Check Initialization Error:", error);
    }
} else {
    if (!showDebugLogs) console.log(` ******* FIREBASE ${isStagingApp ? "STAGING" : "LOCAL"} DEBUG TOKEN MODE 🚧******`, appCheckDebugToken);

    /* eslint-disable no-restricted-globals */
    (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = appCheckDebugToken || true;

    initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(firebaseAppCheckSiteKey),
        isTokenAutoRefreshEnabled: true,
    });
}

export const auth = getAuth();
export const firestore = getFirestore();
export const storage = getStorage();
export const functions = getFunctions(app);
